import IPixelMapDay from "@interfaces/pixel-map-day.interface";

const novemberMap: Array<IPixelMapDay> = [
];

export default novemberMap;
